
function homepageExploreRdesign() {
    if($('.pt_storefront').length) {
        if($('.latest_highlights_main-title_wrapper').length) {
          if($(window).width() < 991) {
            //OverlayScrollbars initialization with an element
              const osInstance = OverlayScrollbars(document.querySelector('.swiper-container'), {});
          } else {
            const osInstance = OverlayScrollbars(document.querySelector('.swiper-container'), {}).destroy(); // Disable for desktop screen
            $('.swiper-wrapper').not('.slick-initialized').slick({
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 3,
                nextArrow: $('.swiper-button-next'),
                prevArrow: $('.swiper-button-prev')
            });
        }
      }
    }
}

//Removed js code from asset
function discoverSliderOldDesign() {
  if($('.pt_storefront').length) {
    $('.responsive').slick({
    infinite: true,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
     {
       breakpoint: 1024,
       settings: {
         slidesToShow: 3,
         slidesToScroll: 3,
         infinite: true,
       }
     },
     {
       breakpoint: 768,
       settings: {
         slidesToShow: 1,
         slidesToScroll: 1,
         autoplay: true,
         arrows: true,
       }
     },
   ]
    });
  }
 }

var exploreSlider = {
    init: function() {
        homepageExploreRdesign();
        discoverSliderOldDesign();
    }
}

$(window).on('resize orientationchange', function () {
    homepageExploreRdesign();
    discoverSliderOldDesign();
});

export default exploreSlider;
